export const initialState = {
  session: {
    JwtToken: null,
    user: {},
  },
  // requests: {
  //   queue: [],
  //   messages: [],
  // },
  banner: {
    list: {},
    current: {},
  },
  image: {
    list: {},
    current: {},
  },
  file: {
    list: {},
    current: {},
  },
  number: {
    list: {},
    current: {},
  },
  nation: {
    list: {},
    current: {},
  },
  activity: {
    list: {},
    current: {},
  },
  video: {
    list: {},
    current: {},
  },
  tag: {
    list: {},
    current: {},
  },
};
